import React, { useEffect } from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultsRSC, getUnits } from "data/Querys"
import Loader from 'components/general/Loader'
import { getPhaseRSC } from 'helpers/rsc'
import ProgressionRule from 'components/common/ProgressionRule'
import NotAvailable from 'components/common/NotAvailable'
//Results
import PageHeader from "components/common/PageHeader";
import RowResults from "components/sports/row/views/RowResults";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import 'styles/modules/RowResults.scss';
import PhotoFinish from "components/general/PhotoFinish";
import { isParalympic } from "helpers/utils";
import RecordsPrototype from "components/general/RecordsPrototype";

const RowContext = () => {
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    let _phase = getPhaseRSC(mirs_rsc);

    const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
        {
            queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase],
            queryFn: getUnits,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );

    let queryArray = [];
    const recordArray = isParalympic(mirs_competition) ? ['WB', 'PGB'] : ['WB', 'OB']


    unitsData?.phase?.units?.forEach((unit) => {

        queryArray.push({
            queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, unit.code, undefined, recordArray],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    const resultsData = useQueries(queryArray);
    const isLoading = unitsLoading || resultsData.some(result => result.isLoading)
    const isError = unitsError || resultsData.some(result => result.isError)
    const results = resultsData.filter(res => res?.data?.results)

    let hasRerow = results?.some(res => res?.data?.results?.eventUnit?.description.includes('Re-Row'))
    if (hasRerow) {
        results.map(res => {
            if (res?.data?.results?.eventUnit?.description.includes('Re-Row'))
                results.push(results.splice(results.indexOf(res), 1)[0]);
        })
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    const dataHeader = unitsData?.phase?.units.find(item => item.code === mirs_rsc)

    return (
        <>
            {results[0]
                ? <><PageHeader title={dataHeader?.description} />
                    <div className='mirs-page-container'>
                        {
                            results[0]?.data?.records &&
                            <RecordsPrototype records={results[0]?.data?.records} forceResultTypeHader="HeaderTime" forceMobileColumns={['Date', 'Location']} headerRecord="Best Time" />
                        }

                        <ProgressionRule
                            key="progress-component"
                            data={results[0]?.data?.config}
                            filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
                        />
                        {results.map((res, index) => {
                            if (res.data?.results?.items !== undefined && res.data?.images !== undefined) {
                                return <>
                                    <PhotoFinish key={`photofinish-component-${index}`} data={res?.data?.images} />
                                    <RowResults key={`results-component-${index}`} data={res.data} />
                                </>
                            }
                            else if (res.data?.results?.items !== undefined)
                                return <RowResults key={`results-component-${index}`} data={res.data} />
                        })
                        }</div>
                </>
                : <NotAvailable />
            }
        </>
    );
};
export default RowContext;